import { useEffect, useRef } from 'react';

var useUpdateEffect = function useUpdateEffect(effect, deps) {
  var isMounted = useRef(false);
  useEffect(function () {
    if (!isMounted.current) {
      isMounted.current = true;
    } else {
      return effect();
    }
  }, deps);
};

export default useUpdateEffect;


//////////////////
// WEBPACK FOOTER
// ./~/ahooks/es/useUpdateEffect/index.js
// module id = 277
// module chunks = 2